import {
  getString,
  getObject,
  getList,
  getLeoDate,
  LeoDate,
} from "@surya-digital/leo-ts-types";


export namespace TableFilterEnums {
  export namespace Input {
    export interface OpenEndedDTO {
      case: string;
      fieldValue: string;
    }
    
    export class OpenEnded {
      readonly isInputOpenEnded: boolean = true;
    
      readonly fieldValue: string;
    
      static readonly constraints = {
        "fieldValue": {
          "minSize": 1,
          "maxSize": 100,
          
          
          
          
        }
      }
    
      constructor(
      fieldValue: string
      ) {
        OpenEnded.validateFieldValue(fieldValue);
        this.fieldValue = fieldValue;
      }
    
      static fromDTO(dto: OpenEndedDTO): OpenEnded {
        const fieldValue = getString(dto, "fieldValue", InvalidTableFilterInputOpenEndedFieldValueError);
        return new OpenEnded(
          fieldValue
        );
      }
    
      toDTO(): OpenEndedDTO {
        const dto: OpenEndedDTO = {
          case: "OPEN_ENDED",
            fieldValue: this.fieldValue
        };
        return dto;
      }
      private static validateFieldValue = (fieldValue: string): void => {
        if(fieldValue.length < 1) {
          throw new InvalidTableFilterInputOpenEndedFieldValueMinSizeError(
            1,
            `Attribute fieldValue is too short. Size is ${fieldValue.length}. Min size is 1.`
          );
        }
        if(fieldValue.length > 100) {
          throw new InvalidTableFilterInputOpenEndedFieldValueMaxSizeError(
            100,
            `Attribute fieldValue is too long. Size is ${fieldValue.length}. Max size is 100.`
          );
        }
          if(fieldValue.trim().length === 0) {
            throw new InvalidTableFilterInputOpenEndedFieldValueNonEmptyError(
              `Attribute fieldValue cannot be an empty string.`
            );
          }
      }
      
    }
    
    OpenEnded.prototype.toString = function toString(): string {
      return `Input.OPEN_ENDED(fieldValue='${this.fieldValue}')`;
    };
    
    export interface PresetMultiSelectDTO {
      case: string;
      values: string[];
    }
    
    export class PresetMultiSelect {
      readonly isInputPresetMultiSelect: boolean = true;
    
      readonly values: string[];
    
      static readonly constraints = {
        "values": {
          "minSize": 1,
        }
      }
    
      constructor(
      values: string[]
      ) {
        PresetMultiSelect.validateValues(values);
        this.values = values;
      }
    
      static fromDTO(dto: PresetMultiSelectDTO): PresetMultiSelect {
        const values = getList<string, string>(
          dto,
          "values",
          (e: string) => e,
          InvalidTableFilterInputPresetMultiSelectValuesError
        );
        return new PresetMultiSelect(
          values
        );
      }
    
      toDTO(): PresetMultiSelectDTO {
        const dto: PresetMultiSelectDTO = {
          case: "PRESET_MULTI_SELECT",
            values: this.values
        };
        return dto;
      }
      private static validateValues = (values: string[]): void => {
        if(values.length < 1) {
          throw new InvalidTableFilterInputPresetMultiSelectValuesMinSizeError(
            1,
            `Attribute values is too short. Size is ${values.length}. Min size is 1.`
          );
        }
      }
      
    }
    
    PresetMultiSelect.prototype.toString = function toString(): string {
      return `Input.PRESET_MULTI_SELECT(values='${this.values}')`;
    };
    
    export interface DateRangeDTO {
      case: string;
      startDate: string;
      endDate: string;
    }
    
    export class DateRange {
      readonly isInputDateRange: boolean = true;
    
      readonly startDate: LeoDate;
      readonly endDate: LeoDate;
    
    
      constructor(
      startDate: LeoDate, 
      endDate: LeoDate
      ) {
        this.startDate = startDate;
        this.endDate = endDate;
      }
    
      static fromDTO(dto: DateRangeDTO): DateRange {
        const startDate = getLeoDate(dto, "startDate", InvalidTableFilterInputDateRangeStartDateError);
        const endDate = getLeoDate(dto, "endDate", InvalidTableFilterInputDateRangeEndDateError);
        return new DateRange(
          startDate,
          endDate
        );
      }
    
      toDTO(): DateRangeDTO {
        const dto: DateRangeDTO = {
          case: "DATE_RANGE",
            startDate: this.startDate.toDTO(),
            endDate: this.endDate.toDTO()
        };
        return dto;
      }
      }
    
    DateRange.prototype.toString = function toString(): string {
      return `Input.DATE_RANGE(startDate='${this.startDate}',endDate='${this.endDate}')`;
    };
    
  
    export type Input = OpenEnded | PresetMultiSelect | DateRange;
  
    export type InputDTO = OpenEndedDTO | PresetMultiSelectDTO | DateRangeDTO;
  
    export const fromDTO = (dto: InputDTO): Input => {
      switch (dto.case) {
        case "OPEN_ENDED":
            return OpenEnded.fromDTO(dto as OpenEndedDTO);
        case "PRESET_MULTI_SELECT":
            return PresetMultiSelect.fromDTO(dto as PresetMultiSelectDTO);
        case "DATE_RANGE":
            return DateRange.fromDTO(dto as DateRangeDTO);
        default:
          throw new InvalidTableFilterInputError(
              `Case ${dto.case} is not valid case of Input.`
          );
      }
    };
  }
  
}
export interface TableFilterDTO {
  key: string;
  input: TableFilterEnums.Input.InputDTO;
}

export class TableFilter {
  readonly isTableFilterTableFilter: boolean = true;

  readonly key: string;
  readonly input: TableFilterEnums.Input.Input;

  static readonly constraints = {
    "key": {
      "minSize": 1,
      "maxSize": 100,
      
      
      
      
    },
  }

  constructor(
  key: string, 
  input: TableFilterEnums.Input.Input
  ) {
    TableFilter.validateKey(key);
    this.key = key;
    this.input = input;
  }

  static fromDTO(dto: TableFilterDTO): TableFilter {
    const key = getString(dto, "key", InvalidTableFilterKeyError);
    const input = TableFilterEnums.Input.fromDTO(getObject(dto, "input", InvalidTableFilterInputError));
    return new TableFilter(
      key,
      input
    );
  }

  toDTO(): TableFilterDTO {
    const dto: TableFilterDTO = {
        key: this.key,
        input: this.input.toDTO()
    };
    return dto;
  }
  private static validateKey = (key: string): void => {
    if(key.length < 1) {
      throw new InvalidTableFilterKeyMinSizeError(
        1,
        `Attribute key is too short. Size is ${key.length}. Min size is 1.`
      );
    }
    if(key.length > 100) {
      throw new InvalidTableFilterKeyMaxSizeError(
        100,
        `Attribute key is too long. Size is ${key.length}. Max size is 100.`
      );
    }
      if(key.trim().length === 0) {
        throw new InvalidTableFilterKeyNonEmptyError(
          `Attribute key cannot be an empty string.`
        );
      }
  }
  
}

TableFilter.prototype.toString = function toString(): string {
  return `TableFilter(key='${this.key}',input='${this.input}')`;
};

export class InvalidTableFilterError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidTableFilterError";
  }
}
export class InvalidTableFilterKeyError extends InvalidTableFilterError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidTableFilterKeyError";
  }
}

export class InvalidTableFilterKeyMaxSizeError extends InvalidTableFilterKeyError {
  readonly maxSize: number;
  constructor(maxSize: number, message?: string) {
    super(message);
    this.maxSize = maxSize;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidTableFilterKeyMaxSizeError";
  }
}

export class InvalidTableFilterKeyMinSizeError extends InvalidTableFilterKeyError {
  readonly minSize: number;
  constructor(minSize: number, message?: string) {
    super(message);
    this.minSize = minSize;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidTableFilterKeyMinSizeError";
  }
}

export class InvalidTableFilterKeyNonEmptyError extends InvalidTableFilterKeyError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidTableFilterKeyNonEmptyError";
  }
}

export class InvalidTableFilterInputError extends InvalidTableFilterError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidTableFilterInputError";
  }
}

export class InvalidTableFilterInputOpenEndedError extends InvalidTableFilterInputError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidTableFilterInputOpenEndedError";
  }
}

export class InvalidTableFilterInputOpenEndedFieldValueError extends InvalidTableFilterInputOpenEndedError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidTableFilterInputOpenEndedFieldValueError";
  }
}

export class InvalidTableFilterInputOpenEndedFieldValueMaxSizeError extends InvalidTableFilterInputOpenEndedFieldValueError {
  readonly maxSize: number;
  constructor(maxSize: number, message?: string) {
    super(message);
    this.maxSize = maxSize;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidTableFilterInputOpenEndedFieldValueMaxSizeError";
  }
}

export class InvalidTableFilterInputOpenEndedFieldValueMinSizeError extends InvalidTableFilterInputOpenEndedFieldValueError {
  readonly minSize: number;
  constructor(minSize: number, message?: string) {
    super(message);
    this.minSize = minSize;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidTableFilterInputOpenEndedFieldValueMinSizeError";
  }
}

export class InvalidTableFilterInputOpenEndedFieldValueNonEmptyError extends InvalidTableFilterInputOpenEndedFieldValueError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidTableFilterInputOpenEndedFieldValueNonEmptyError";
  }
}

export class InvalidTableFilterInputPresetMultiSelectError extends InvalidTableFilterInputError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidTableFilterInputPresetMultiSelectError";
  }
}

export class InvalidTableFilterInputPresetMultiSelectValuesError extends InvalidTableFilterInputPresetMultiSelectError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidTableFilterInputPresetMultiSelectValuesError";
  }
}

export class InvalidTableFilterInputPresetMultiSelectValuesMinSizeError extends InvalidTableFilterInputPresetMultiSelectValuesError {
  readonly minSize: number;
  constructor(minSize: number, message?: string) {
    super(message);
    this.minSize = minSize;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidTableFilterInputPresetMultiSelectValuesMinSizeError";
  }
}

export class InvalidTableFilterInputDateRangeError extends InvalidTableFilterInputError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidTableFilterInputDateRangeError";
  }
}

export class InvalidTableFilterInputDateRangeStartDateError extends InvalidTableFilterInputDateRangeError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidTableFilterInputDateRangeStartDateError";
  }
}

export class InvalidTableFilterInputDateRangeEndDateError extends InvalidTableFilterInputDateRangeError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidTableFilterInputDateRangeEndDateError";
  }
}
